module.exports = __webpack_public_path__ + "img/1-2.1刘同（作家）.9a555832.jpg";